import { define } from "remount";
import { ArticleTableOfContents } from "../src/ArticleTableOfContents";

document.addEventListener("DOMContentLoaded", () => {
  define({
    "article-table-of-contents": ArticleTableOfContents,
  });
});
